import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ApiBienestarService } from '../service/api-bienestar.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    public apiBienestarService: ApiBienestarService
  ) {}
  canActivate() {
    if (this.apiBienestarService.getCurrentUser()) {
      return true;
    } else {
      // window.location.href = 'http://loginfront.azurewebsites.net/';
      return false;
    }
  }
}
